/** 需采用按需加载 */
import Vue from 'vue'
import VueRouter from 'vue-router'

/** layout */
const TabBarLayout = () => import('@/views/layout/tabBarLayout')

/** 我的奖励 */
const MyReward = () => import('@/views/myReward')

/** 结算卡 */
const Settle = () => import('@/views/settle/settleCard')

/** 我的客户 */
const MyClient = () => import('@/views/myClient')

/** 合伙人指引 */
const Guide = () => import('@/views/partnerGuidelines')

/** 奖励详情 */
const Reward = () => import('../views/detail/reward.vue')

/** 结算记录详情 */
const SettleRecord = () => import('../views/detail/settleRecord.vue')

/** 扫码展示页 */
const scanIndex = () => import('@/views/scanIndex')

/** 请在微信中打开 */
const plsWechat = () => import('@/views/plsWechat')

Vue.use(VueRouter)

// 解决vue-router在3.0以上版本中，重复点击相同跳转链接时报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  /** 主页 */
  {
    path: '/',
    name: 'Home',
    component: TabBarLayout,
    children: [
      {
        path: '',
        component: () => import('@/views/home')
      }
    ]
  },
  /** 我的奖励 */
  {
    path: '/myReward',
    name: 'MyReward',
    component: TabBarLayout,
    children: [
      {path: '', component: MyReward}
    ]
  },
  /** 我的客户 */
  {
    path: '/myClient',
    name: 'MyClient',
    component: TabBarLayout,
    children: [
      {path: '', component: MyClient}
    ]
  },

  /** 当前等级 */
  {
    path: '/level',
    name: 'level',
    component: () => import('@/views/level'),
    meta: {
      title: '当前等级'
    }
  },
  /** 新增银行卡 */
  {
    path: '/addCard',
    name: 'addCard',
    component: () => import('@/views/addCard'),
    meta: {
      title: '卡管理'
    }
  },

  /** 合伙人指引 */
  {
    path: '/guide',
    name: 'guide',
    component: Guide,
    meta: {
      title: '合伙人指引'
    }
  },

  /** 协议页 */
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('@/views/agreement'),
    meta: {
      title: '协议查看'
    }
  },

  /** 结算卡 */
  {
    path: '/settle',
    name: 'settle',
    component: Settle
  },

  /** 奖励详情 */
  {
    path: '/reward',
    name: 'reward',
    component: Reward
  },

  /** 结算记录详情 */
  {
    path: '/settleRecord',
    name: 'settleRecord',
    component: SettleRecord
  },
  {
    path: '/savePic',
    name: 'savePic',
    component: () => import('@/views/savePic')
  },

  /** 扫码展示页 */
  {
    path: '/scan',
    name: 'scanIndex',
    component: scanIndex
  },

  /** 请在微信中打开 */
  {
    path: '/plswechat',
    name: 'plsWechat',
    component: plsWechat
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    document.title = '光子易推广大使'
  }
  // 判断是否微信浏览器
  const ua = navigator.userAgent.toLowerCase()
  const isWeixin = ua.indexOf('micromessenger') !== -1
  const noWeChat = ['scanIndex', 'plsWechat']
  if (!isWeixin && !noWeChat.includes(to.name)) {
      next('/plsWechat')
      return
  }
  next()
})
export default router
